import { Accordion } from '../../../../../components/general/accordion';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import AppsIcon from '@mui/icons-material/Apps';
import ChatIcon from '@mui/icons-material/Chat';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PhoneIcon from '@mui/icons-material/Phone';
import { InteractionHistoryPQR } from './pqr/HistoryPQR';
import { HistoryEmailSending } from './emailSending/HistoryEmailSending';
import { InteractionHistoryProps } from './props';
import { HistoryOthersSection } from './HistoryOthersSection';

export const InteractionHistory = ({ account }: InteractionHistoryProps) => {
    return (
        <Accordion
            title="HISTÓRICO DE INTERACCIÓN"
            defaultExpanded={false}
            icon={<WorkHistoryIcon sx={{ color: 'primary.main' }} />}
            mt={0}
        >
            <HistoryOthersSection
                title="HISTÓRICO APP"
                Icon={AppsIcon}
                channel="APP"
                account={account}
            />

            <HistoryOthersSection
                title="HISTÓRICO CHAT"
                Icon={ChatIcon}
                channel="CHAT"
                account={account}
            />

            <HistoryOthersSection
                title="HISTÓRICO CHATBOT"
                Icon={SmartToyIcon}
                channel="CHATBOT"
                account={account}
            />

            <HistoryOthersSection
                title="HISTÓRICO TELEFONÍA"
                Icon={PhoneIcon}
                channel="TELEFONÍA"
                account={account}
            />

            <HistoryEmailSending account={account} />

            <InteractionHistoryPQR account={account} />
        </Accordion>
    );
};
